/** Prompts for Cursor coach requests from the Chess page. */

export function buildExplainPositionPrompt(opts: {
  fen: string;
  pgn: string;
  turnLabel: 'White' | 'Black';
}): string {
  return `You are a chess Grandmaster. Analyze the following position.

The current position is: ${opts.fen}
It is ${opts.turnLabel}'s turn to move.

Game so far (PGN):
${opts.pgn.trim() || '(no moves yet)'}

Please evaluate this position and do the following:
1. Give the 3 best candidate moves (with brief justification each).
2. Explain the strategic plan and ideas behind each move.
3. Assess the current state of the board in terms of piece activity, pawn structure, and king safety.

Write in clear prose for a club player. Use numbered lists where helpful.`;
}

export function buildAnalyzeGamePrompt(pgn: string): string {
  return `Act as my chess coach. I am going to paste the PGN of my recent game:

${pgn.trim()}

Please provide a review of this game by doing the following:
A. Identify the most critical turning point or mistake made in the game.
B. Explain the overarching strategy each player was trying to achieve.
C. Provide 3 key learning points and suggest what I could have done differently.

Write in clear prose for a club player. Reference specific moves from the PGN when possible.`;
}
